
import { handleAxiosException } from '@/api'
import { GetAllMyArqanaHorseRegistrationDto, MinimalPersonContact, MixRegistrationOwnerRequest, myRegistrationApi, RegistrationOwnerRequest } from '@/api/auth/myHorseRegistration'
import snackbarStore from '@/store/snackbarStore'
import Vue from 'vue'
import store from '@/store'
import KAutocomplete from '@/components/shared/KAutocomplete.vue'
import rules, { isRequiredGenerator } from '@/utils/rules'
import { lotSellerApi } from '@/api/lotSeller'
import { formatAddress } from '@/utils/addresses'
import { countBy, Dictionary } from 'lodash'

export default Vue.extend({
  name: 'OwnerRegistration',
  components: { KAutocomplete },
  props: {
    registrationId: { required: false, type: Number },
    value: { required: true, type: Boolean },
    // registration: Object as () => GetAllMyArqanaHorseRegistrationDto,
  },
  data() {
    return {
      rules,
      loading: true,
      valid: true,
      error: '',
      store,
      editing: false,
      registration: {} as GetAllMyArqanaHorseRegistrationDto,
      owners: [] as RegistrationOwnerRequest[],
    }
  },
  methods: {
    isRequiredGenerator,
    formatAddress,
    async load() {
      try {
        this.loading = true
        this.owners = []
        this.registration = await myRegistrationApi.findById(this.registrationId)
        this.registration.owners.forEach(o => this.owners.push({ lotSellerId: o.lotSeller.id, part: o.part }))
      } catch (err) {
        snackbarStore.setError(handleAxiosException(err))
      } finally {
        this.loading = false
      }
    },
    removeOwner(i: number) {
      this.owners.splice(i, 1)
      this.registration.owners.splice(i, 1)
      // this.ownerKeys.splice(i, 1)
    },
    addOwner() {
      this.owners.push({ lotSellerId: 0, part: 100 })
      this.registration.owners.push({ lotSeller: {} as MinimalPersonContact, part: 100 })
      // eslint-disable-next-line no-plusplus
      // this.ownerKeys.push(idAutoIncrement++)
    },
    calculateParts() {
      switch (this.owners.length) {
        case 1:
          this.owners[0].part = 100
          break
        case 2:
          this.owners[0].part = 50
          this.owners[1].part = 50
          break
        case 3:
          this.owners[0].part = 50
          this.owners[1].part = 25
          this.owners[2].part = 25
          break
        case 4:
          this.owners[0].part = 50
          this.owners[1].part = 20
          this.owners[2].part = 20
          this.owners[3].part = 10
          break
        default:
      }
    },
    async callbackOwners(filter: string) {
      return (await lotSellerApi.getAllLotSellers({ size: 20, name: filter })).content
    },
    closeDialog() {
      this.$emit('close')
    },
    async save() {
      if ((this.$refs.form as HTMLFormElement).validate()) {
        try {
          this.editing = true
          const ownersRequest = [...this.registration.owners.map(o => ({ lotSellerId: o.lotSeller.id, internal: o.lotSeller.isInternal, part: o.part }))] as MixRegistrationOwnerRequest[]
          await myRegistrationApi.updateRegistrationOwners(this.registrationId, ownersRequest)
          this.closeDialog()
        } catch (err) {
          snackbarStore.setError(handleAxiosException(err))
        } finally {
          this.editing = false
        }
      }
    },
    isTrot(): boolean {
      return !!process.env.VUE_APP_IS_TROT
    },
  },
  computed: {
    ruleAllPartBelow100(): undefined | string {
      // if (this.owners.reduce((p, c) => p + c.part, 0) === 100) {
      if (this.registration.owners.reduce((p, c) => p + c.part, 0) === 100) {
        return undefined
      } else {
        return 'La somme totale des parts doit être égale à 100%'
      }
    },
    isPercentageStrictPositive() {
      return (v: number) => v >= 1 && v <= 100 || 'La valeur doit être comprise entre 1 et 100'
    },
    ownerCount(): Dictionary<number> {
      // return countBy(this.owners, (el) => el.lotSellerId)
      return countBy(this.registration.owners.filter(o => !o.lotSeller.isInternal), (el) => el.lotSeller.id)
    },
    // duplicateOwner(): boolean {
    //   let internal = 0
    //   let extrenal = 0
    //   const internalSet = new Set()
    //   const externalSet = new Set()
    //   this.registration.owners.forEach(o => {
    //     if (o.lotSeller.isInternal) {
    //       internal += 1
    //       internalSet.add(o.lotSeller.id)
    //     } else {
    //       extrenal += 1
    //       externalSet.add(o.lotSeller.id)
    //     }
    //   })
    //   return internal === internalSet.size && externalSet.size === extrenal
    // },
  },
  mounted() {
    // this.load()
  },
  watch: {
    registrationId: {
      handler(val, oldVal) {
        if (val && val !== oldVal && this.value) {
          // this.load()
        }
      },
    },
    value: {
      handler(val) {
        if (!val) {
          this.closeDialog()
        } else if (this.registrationId) {
          // eslint-disable-next-line no-unused-expressions
          (this.$refs.form as HTMLFormElement | undefined)?.resetValidation()
          this.valid = true
          this.error = ''
          this.load()
        }
      },
    },
  },

})
